import { render, staticRenderFns } from "./MemberLoanOverview.vue?vue&type=template&id=15f603bb"
import script from "./MemberLoanOverview.vue?vue&type=script&lang=js"
export * from "./MemberLoanOverview.vue?vue&type=script&lang=js"
import style0 from "./MemberLoanOverview.vue?vue&type=style&index=0&id=15f603bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports